import AsyncStorage from '@react-native-async-storage/async-storage';
import type { KeyValueStoragePort } from '../../application/ports/key-value-storage-port';

export const AsyncStorageKeyValueStorage: KeyValueStoragePort = {
  getString: key => AsyncStorage.getItem(key),
  setString: (key, value) => AsyncStorage.setItem(key, value),
  remove: key => AsyncStorage.removeItem(key),
};
